import { useState, useEffect } from 'react';
import api from '../config/api';
import useStore from '../config/store';

const DEFAULT_SENDER = 'Amanda HR';

/**
 * Hook para el nombre del remitente de los correos ATS.
 * Al abrir un diálogo de envío (open=true), carga la config del proyecto
 * (/projects/ats-email-sender) y prellena el nombre según el modo:
 * 'default' → Amanda HR | 'user' → nombre del usuario logueado | 'custom' → texto guardado.
 * El valor es editable por el usuario antes de enviar (se pasa como senderName al backend).
 * Solo cambia el nombre visible; la dirección de envío no es configurable.
 */
const useAtsSenderName = (open) => {
  const { organization, project, authToken, user } = useStore.getState();
  const [senderName, setSenderName] = useState(DEFAULT_SENDER);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;

    const load = async () => {
      let name = DEFAULT_SENDER;
      try {
        if (organization && project) {
          const res = await api.get(`/projects/ats-email-sender`, {
            params: { organizationId: organization, projectId: project },
            headers: { Authorization: `Bearer ${authToken}` },
          });
          const cfg = res.data.response?.data || {};
          const userName = user?.name || user?.displayName || '';
          if (cfg.mode === 'custom') name = cfg.customName || DEFAULT_SENDER;
          else if (cfg.mode === 'user') name = userName || cfg.customName || DEFAULT_SENDER;
        }
      } catch (err) {
        console.error('Error loading ATS email sender config:', err);
      }
      if (!cancelled) setSenderName(name);
    };
    load();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return { senderName, setSenderName };
};

export default useAtsSenderName;
